module.exports = __webpack_public_path__ + "img/card-change-sms.8d8e6bcc.png";